import { useState, useEffect } from "react";
import { SketchPicker } from "react-color";

interface Props {
  label?: string;
  value?: string;
  onChange: (color: string) => void;
  labelClassName?: string;
  error?: boolean;
}

export const FormColorPicker = ({
  label,
  value = "", // provide default value
  onChange,
  labelClassName,
  error,
}: Props) => {
  /** State */
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [color, setColor] = useState(value);

  // Sync local state with prop value when it changes
  useEffect(() => {
    setColor(value);
  }, [value]);

  const onColorChange = (color: any) => setColor(color.hex);
  const onColorChangeComplete = (color: any) => {
    onChange(color.hex);
    setShowColorPicker(false);
  };

  // Stop event propagation when clicking the color picker
  const handlePickerClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <>
      <div className="mb-4">
        <p
          className={`font-satoshi text-dark text-sm font-medium mb-3 ${labelClassName}`}
        >
          {label}
        </p>
        <div
          className={`w-full h-[46px] px-4 bg-sky-lighter border ${
            error ? "border-red-base" : "border-gray-border"
          } ${
            error ? "focus:border-red-base" : "focus:border-focused-border"
          } rounded font-satoshi text-base text-dark font-medium outline-none flex flex-row items-center justify-between`}
        >
          <div className="flex flex-row items-center w-[100%] h-[100%]">
            {color && (
              <div
                onClick={() => {
                  setColor("");
                  onChange("");
                  setShowColorPicker(false);
                }}
                style={{ backgroundColor: color }}
                className={`w-[15px] h-[15px] mr-1 cursor-pointer rounded`}
              />
            )}
          </div>
          <button
            onClick={() => setShowColorPicker(!showColorPicker)}
            type="button"
            className="px-[8px] py-[3px] bg-primary-base font-satoshi font-medium text-white text-sm rounded"
          >
            {color ? "Edit" : "Add"}
          </button>
        </div>
      </div>
      {showColorPicker && (
        <div
          style={{
            position: "absolute",
            zIndex: 2,
          }}
          onClick={handlePickerClick}
        >
          <SketchPicker
            color={color}
            onChangeComplete={onColorChangeComplete}
            onChange={onColorChange}
          />
        </div>
      )}
    </>
  );
};
